import projectsService from '../../services/projectsService';
import dataModel from '../../models/DataModel';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants';

export default class UserProjectsCollection extends AOCollection {

  // DO NOT CALL THIS DIRECTLY USE THE BUILD METHODS BELOW TO INSTANTIATE
  constructor(userId, page, perPage) {
    
    super({
      name: ReduxConstants.USER_PROJECTS,
      collectionType: ReduxConstants.PROJECT,
      userId,
      page,
      perPage,
      searchString: null,
    });
  }

  static build(userId, options) {
    let page = options && options.page ? options.page : null;
    let perPage = options && options.perPage ? options.perPage : null;
    let collection = new UserProjectsCollection(userId, page, perPage);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let collection = this.getDenormalizedCollection(options);
      if (!collection) {
        collection = this.getData();
      }
      if (collection) {
        collection.projects = dataModel.projectsDAO.getOfflineProjects(options);
        collection.ids = collection.projects.map(project => { return project.id; });
      }
      return resolve(collection);
    });
  }

  async fetchNext(pageOverride, options = {}) {
    if (dataModel.isOffline) {
      return new Promise((resolve) => {
        const collection = this.findCollection();
        if (collection) {
          let ids = [];
          let completed = 0;
          let count = 0;
          for (const key in dataModel.collectionsDAO.stateTree.new_projects) {
            if (key) {
              const project = dataModel.collectionsDAO.stateTree.new_projects[key];
              if (project && project.company_id == localStorage.current_company_id && (project.is_favorite ||
                (project._dirty))) {
                count++;
                if (project.tasks_completed_count == project.tasks_count) {
                  completed++;
                }
                ids.push(project.id);
              }
            }
          }
          const clonedCollection = Object.assign({}, collection, { ids: ids, completed: completed, count: count });
          this.markSynced(clonedCollection);
          dataModel.collectionsDAO.setCollection(this.getKey(), clonedCollection, this.getCollectionType());
          resolve(this.getDenormalizedCollection(options));
        }
      });
    }
    else {
      return new Promise(async (resolve) => {
        if (pageOverride) {
          this.page = pageOverride;
        }
        else{
          this.page++;
        }
        if (!options) {
          options = {};
        }
        options.ignoreCompleted = true;
        let serviceCall = projectsService.getUserProjects.bind(this, this.page, this.perPage, { id: this.userId }, null, this.searchString, 'is_favorite', true, options);
      
        let newCollection = await this._fetchData(serviceCall, options, true);

        if (newCollection.meta) {
          newCollection.completed = newCollection.meta.completed_projects;
          newCollection.count = newCollection.meta.total_projects;
        }
        return resolve (newCollection);
      });
    }
  }

  // used by action cable
  fetchCurrent(shouldPaginate, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let collection = this.findCollection();

        let page = null;
        let perPage = null;
        
        // Get everything we already got
        if (shouldPaginate) {
          page = 1;
          if (collection && collection.perPage) {
            perPage = Math.max(this.perPage, collection.ids.length);
          }
        }
    
        if (!options) {
          options = {};
        }
        options.ignoreCompleted = true;

        let serviceCall = projectsService.getUserProjects.bind(this, page, perPage, { id: this.userId }, null, this.searchString, 'is_favorite', true, options);

        let newCollection = await this._fetchData(serviceCall, options);

        if (newCollection.offline) {
          console.log('offline in current');
          return this.handleOffLineFetch(options);
        }
    
        if (newCollection.meta) {
          newCollection.completed = newCollection.meta.completed_projects;
          newCollection.count = newCollection.meta.total_projects;
        }
        return resolve(newCollection);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/UserProjectsCollection.js